const PARSER_VALUE_TYPES = [
  { group: 'Basic', base_unit: null, name: 'Unset', descr: 'Undefined type', factor: 1 },
  { group: 'Basic', base_unit: 'number', name: 'Number', descr: 'Number', factor: 1 },
  { group: 'Basic', base_unit: 'boolean', name: 'Boolean', descr: 'Boolean', factor: null },
  { group: 'Basic', base_unit: 'string', name: 'String', descr: 'String', factor: null },
  { group: 'Basic', base_unit: '%', name: '%', descr: 'Percent (0-100)', factor: 1 },
  { group: 'Basic', base_unit: '%', name: '%', descr: 'Percent (0.0-1.0)', factor: 100 },
  { group: 'Basic', base_unit: '%H', name: '%h', descr: 'Percent humidity', factor: 1 },
  { group: 'Temperature', base_unit: '°C', name: '°C', descr: 'Deg. Celsius', factor: 1 },
  { group: 'Temperature', base_unit: '°F', name: '°F', descr: 'Deg. Fahrenheit', factor: 1 },
  { group: 'Temperature', base_unit: 'K', name: 'K', descr: 'Kelvin', factor: 1 },
  { group: 'Energy', base_unit: 'A', name: 'A', descr: 'Ampere', factor: 1 },
  { group: 'Energy', base_unit: 'A', name: 'mA', descr: 'Milliampere', factor: 0.001 },
  { group: 'Energy', base_unit: 'lx', name: 'lx', descr: 'Lux', factor: 1 },
  { group: 'Energy', base_unit: 'lm', name: 'lm', descr: 'Lumen', factor: 1 },
  { group: 'Energy', base_unit: 'dB', name: 'dB', descr: 'Decibel', factor: 1 },
  { group: 'Energy', base_unit: 'V', name: 'mV', descr: 'Millivolt', factor: 0.001 },
  { group: 'Energy', base_unit: 'V', name: 'V', descr: 'Volt', factor: 1 },
  { group: 'Energy', base_unit: 'V', name: 'kV', descr: 'Kilovolt', factor: 1000 },
  { group: 'Power', base_unit: 'Wm2', name: 'W/m2', descr: 'Watt per square meter', factor: 1 },
  { group: 'Power', base_unit: 'W', name: 'W', descr: 'Watt', factor: 1 },
  { group: 'Power', base_unit: 'W', name: 'kW', descr: 'Kilowatt', factor: 1000 },
  { group: 'Power', base_unit: 'W', name: 'MW', descr: 'Megawatt', factor: 1000000 },
  { group: 'Energy', base_unit: 'Wh', name: 'Wh', descr: 'Watt Hour', factor: 1 },
  { group: 'Energy', base_unit: 'Wh', name: 'kWh', descr: 'Kilowatt Hour', factor: 1000 },
  { group: 'Energy', base_unit: 'Wh', name: 'MWh', descr: 'Megawatt Hour', factor: 1000000 },
  { group: 'Concentration', base_unit: 'ppm', name: 'ppm', descr: 'Parts-per-million', factor: 1 },
  { group: 'Concentration', base_unit: 'gl', name: 'g/l', descr: 'Grams per liter ', factor: 1 }, // mass concentration
  { group: 'Concentration', base_unit: 'gl', name: 'mg/l', descr: 'Milligrams per liter ', factor: 0.001 }, // mass concentration
  { group: 'Concentration', base_unit: 'gl', name: 'ug/l', descr: 'Microgram per liter (2) ', factor: 0.000001 }, // mass concentration
  { group: 'Concentration', base_unit: 'gl', name: 'µg/l', descr: 'Microgram per liter ', factor: 0.000001 }, // mass concentration
  { group: 'Pressure', base_unit: 'Pa', name: 'Pa', descr: 'Pascal', factor: 1 },
  { group: 'Pressure', base_unit: 'Pa', name: 'hPa', descr: 'Hecto Pascal', factor: 100 }, // 1 hPa = 100 Pa
  { group: 'Pressure', base_unit: 'Pa', name: 'kPa', descr: 'Kilo Pascal', factor: 1000 }, // 1 kPa = 1000 Pa
  { group: 'Pressure', base_unit: 'bar', name: 'bar', descr: 'Bar', factor: 1 },
  { group: 'Volume', base_unit: 'l', name: 'l', descr: 'Liter', factor: 1 },
  { group: 'Volume', base_unit: 'm3', name: 'm3', descr: 'Cubic Metre', factor: 1 },
  { group: 'Volume', base_unit: 'lh', name: 'l/h', descr: 'Liter per Hour', factor: 1 }, // Volume flow rate
  { group: 'Volume', base_unit: 'lm', name: 'l/min', descr: 'Liter per Minute', factor: 1 }, // Volume flow rate
  { group: 'Volume', base_unit: 'ls', name: 'l/s', descr: 'Liter per Second', factor: 1 }, // Volume flow rate
  { group: 'Volume', base_unit: 'm3h', name: 'm3/h', descr: 'Cubic Metre per hour', factor: 1 }, // Volume flow rate
  { group: 'Distance', base_unit: 'm', name: 'm', descr: 'Meter', factor: 1 },
  { group: 'Distance', base_unit: 'm', name: 'cm', descr: 'Centimeter', factor: 0.01 },
  { group: 'Distance', base_unit: 'm', name: 'mm', descr: 'Millimeter', factor: 0.001 },
  { group: 'Time', base_unit: 's', name: 's', descr: 'Second', factor: 1 },
  { group: 'Time', base_unit: 'min', name: 'min', descr: 'Minute', factor: 1 },
  { group: 'Time', base_unit: 'h', name: 'h', descr: 'Hour', factor: 1 },
  { group: 'Time', base_unit: 'd', name: 'd', descr: 'Day', factor: 1 },
  { group: 'Power', base_unit: 'VA', name: 'VA', descr: 'Voltampere', factor: 1 },
  { group: 'Power', base_unit: 'kVA', name: 'kVA', descr: 'Kilo Voltampere', factor: 1000 },
  { group: 'Power', base_unit: 'Var', name: 'Var', descr: 'Reactive power', factor: 1 },
  { group: 'Power', base_unit: 'kVar', name: 'kVar', descr: 'Reactive power', factor: 1000 },
  { group: 'Power', base_unit: 'Ah', name: 'A/h', descr: 'Ampere Hour', factor: 1 },
  { group: 'Power', base_unit: 'mAh', name: 'mA/h', descr: 'Milliampere Hour', factor: 0.001 },
  { group: 'Turbidity', base_unit: 'NTU', name: 'NTU', descr: 'Nephelometric Turbidity Unit', factor: 1 },
  { group: 'Turbidity', base_unit: 'FNU', name: 'FNU', descr: 'Formazin Nephelometric Units', factor: 1 },
  { group: 'Turbidity', base_unit: 'FTU', name: 'FTU', descr: 'Formazin Turbidity Units', factor: 1 },
  { group: 'Turbidity', base_unit: 'FAU', name: 'FAU', descr: 'Formazin Attenuation Units', factor: 1 },
  { group: 'Turbidity', base_unit: 'JTU', name: 'JTU', descr: ' Jackson Turbidity Unit', factor: 1 },
  { group: 'Other', base_unit: 'm-1', name: '1/m', descr: 'one per meter (Wave number)', factor: 1 }, // wave number
  { group: 'Other', base_unit: 'cm-1', name: '1/cm', descr: 'one per Centimeter (Wave number)', factor: 0.01 }, // wave number
];

const PARSER_CUSTOM = [
  {
    id: 'abeeway_industrial_tracker',
    name: 'Abeeway Industrial Tracker',
    fields: {},
  },
  {
    id: 'g3',
    name: 'Cyble4IoT/G3 Software DS51',
    fields: {},
  },
  {
    id: 'cyble5',
    name: 'Cyble 5 (Itron)',
    fields: {
      date_time: {
        name: 'date_time',
        order: 1,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'string', name: 'String', descr: 'String', factor: null },
      },
      pulse_weight_l: {
        name: 'pulse_weight_l',
        order: 2,
        type: 'auto',
        value_type: { group: 'Volume', base_unit: 'l', name: 'l', descr: 'Liter', factor: 1 },
      },
      register_digits: {
        name: 'register_digits',
        order: 3,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'number', name: 'Number', descr: 'Number', factor: 1 },
      },
      meter_id: {
        name: 'meter_id',
        order: 4,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'string', name: 'String', descr: 'String', factor: null },
      },
      firmware_version: {
        name: 'firmware_version',
        order: 5,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'string', name: 'String', descr: 'String', factor: null },
      },
      hardware_version: {
        name: 'hardware_version',
        order: 6,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'string', name: 'String', descr: 'String', factor: null },
      },
      battery_lifetime: {
        name: 'battery_lifetime',
        order: 7,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'number', name: 'Number', descr: 'Number', factor: 1 },
      },
      volume_index: {
        name: 'volume_index',
        order: 8,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'number', name: 'Number', descr: 'Number', factor: 1 },
      },
      backflow_index: {
        name: 'backflow_index',
        order: 9,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'number', name: 'Number', descr: 'Number', factor: 1 },
      },
      volume_index_l: {
        name: 'volume_index_l',
        order: 10,
        type: 'auto',
        value_type: { group: 'Volume', base_unit: 'l', name: 'l', descr: 'Liter', factor: 1 },
      },
      backflow_index_l: {
        name: 'backflow_index_l',
        order: 11,
        type: 'auto',
        value_type: { group: 'Volume', base_unit: 'l', name: 'l', descr: 'Liter', factor: 1 },
      },
      alarm_reversed_meter: {
        name: 'alarm_reversed_meter',
        order: 12,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'number', name: 'Number', descr: 'Number', factor: 1 },
      },
      alarm_meter_blocked: {
        name: 'alarm_meter_blocked',
        order: 13,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'number', name: 'Number', descr: 'Number', factor: 1 },
      },
      alarm_battery: {
        name: 'alarm_battery',
        order: 14,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'number', name: 'Number', descr: 'Number', factor: 1 },
      },
      alarm_detection: {
        name: 'alarm_detection',
        order: 15,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'number', name: 'Number', descr: 'Number', factor: 1 },
      },
      alarm_magnetic_tamper: {
        name: 'alarm_magnetic_tamper',
        order: 16,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'number', name: 'Number', descr: 'Number', factor: 1 },
      },
      alarm_memorized_removal: {
        name: 'alarm_memorized_removal',
        order: 17,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'number', name: 'Number', descr: 'Number', factor: 1 },
      },
      alarm_wmbus_credit: {
        name: 'alarm_wmbus_credit',
        order: 18,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'number', name: 'Number', descr: 'Number', factor: 1 },
      },
      alarm_daily_backflow: {
        name: 'alarm_daily_backflow',
        order: 19,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'number', name: 'Number', descr: 'Number', factor: 1 },
      },
      alarm_daily_leakage: {
        name: 'alarm_daily_leakage',
        order: 20,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'number', name: 'Number', descr: 'Number', factor: 1 },
      },
      alarm_daily_peak_flow: {
        name: 'alarm_daily_peak_flow',
        order: 21,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'number', name: 'Number', descr: 'Number', factor: 1 },
      },
      alarm_daily_temperature_above: {
        name: 'alarm_daily_temperature_above',
        order: 22,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'number', name: 'Number', descr: 'Number', factor: 1 },
      },
      alarm_daily_temperature_below: {
        name: 'alarm_daily_temperature_below',
        order: 23,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'number', name: 'Number', descr: 'Number', factor: 1 },
      },
      alarm_monthly_volume_above: {
        name: 'alarm_monthly_volume_above',
        order: 24,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'number', name: 'Number', descr: 'Number', factor: 1 },
      },
      alarm_monthly_volume_below: {
        name: 'alarm_monthly_volume_below',
        order: 25,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'number', name: 'Number', descr: 'Number', factor: 1 },
      },
      fdr_redundancy: {
        name: 'fdr_redundancy',
        order: 26,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'boolean', name: 'Boolean', descr: 'Boolean', factor: null },
      },
      fdr_period: {
        name: 'fdr_period',
        order: 27,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'string', name: 'String', descr: 'String', factor: null },
      },
      fdr_hour: {
        name: 'fdr_hour',
        order: 28,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'number', name: 'Number', descr: 'Number', factor: 1 },
      },
      fdr_steps: {
        name: 'fdr_steps',
        order: 29,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'number', name: 'Number', descr: 'Number', factor: 1 },
      },
      fdr_pulse_weight_l: {
        name: 'fdr_pulse_weight_l',
        order: 30,
        type: 'auto',
        value_type: { group: 'Volume', base_unit: 'l', name: 'l', descr: 'Liter', factor: 1 },
      },
      fdr_volume_index: {
        name: 'fdr_volume_index',
        order: 31,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'number', name: 'Number', descr: 'Number', factor: 1 },
      },
      fdr_volume_index_l: {
        name: 'fdr_volume_index_l',
        order: 32,
        type: 'auto',
        value_type: { group: 'Volume', base_unit: 'l', name: 'l', descr: 'Liter', factor: 1 },
      },
      fdr_generated_at: {
        name: 'fdr_generated_at',
        order: 33,
        type: 'auto',
        value_type: { group: 'Basic', base_unit: 'string', name: 'String', descr: 'String', factor: null },
      },
      consumption_l: {
        name: 'consumption_l',
        order: 34,
        type: 'auto',
        value_type: { group: 'Volume', base_unit: 'l', name: 'l', descr: 'Liter', factor: 1 },
      },
      consumption_m3: {
        name: 'consumption_m3',
        order: 35,
        type: 'auto',
        value_type: { group: 'Volume', base_unit: 'm3', name: 'm3', descr: 'Cubic Metre', factor: 1 },
      },
      cumulative_l: {
        name: 'cumulative_l',
        order: 36,
        type: 'auto',
        value_type: { group: 'Volume', base_unit: 'l', name: 'l', descr: 'Liter', factor: 1 },
      },
      cumulative_m3: {
        name: 'cumulative_m3',
        order: 37,
        type: 'auto',
        value_type: { group: 'Volume', base_unit: 'm3', name: 'm3', descr: 'Cubic Metre', factor: 1 },
      },
      consumption_l_hourly_1: {
        name: 'consumption_l_hourly_1',
        order: 38,
        type: 'auto',
        value_type: { group: 'Volume', base_unit: 'l', name: 'l', descr: 'Liter', factor: 1 },
      },
      consumption_m3_hourly_1: {
        name: 'consumption_m3_hourly_1',
        order: 39,
        type: 'auto',
        value_type: { group: 'Volume', base_unit: 'm3', name: 'm3', descr: 'Cubic Metre', factor: 1 },
      },
      consumption_l_hourly_24: {
        name: 'consumption_l_hourly_24',
        order: 40,
        type: 'auto',
        value_type: { group: 'Volume', base_unit: 'l', name: 'l', descr: 'Liter', factor: 1 },
      },
      consumption_m3_hourly_24: {
        name: 'consumption_m3_hourly_24',
        order: 41,
        type: 'auto',
        value_type: { group: 'Volume', base_unit: 'm3', name: 'm3', descr: 'Cubic Metre', factor: 1 },
      },
    },
  },
  {
    id: 'dzg_loramod_v2',
    name: 'DZG LoRaMod V2',
    fields: {},
  },
  {
    id: 'elsys',
    name: 'Elsys',
    fields: {},
  },
  {
    id: 'elvaco_cmi_4110_uh_50',
    name: 'Elvaco CMi4110 UH50',
    fields: {},
  },
  {
    id: 'keller',
    name: 'KELLER',
    fields: {},
  },
  {
    id: 'keller_manometer_leo5',
    name: 'KELLER Manometer LEO5',
    fields: {},
  },
  {
    id: 'nas_wml',
    name: 'NAS WML',
    fields: {},
  },
  {
    id: 'nas_wmr',
    name: 'NAS WMR',
    fields: {},
  },
  {
    id: 'nke',
    name: 'NKE',
    fields: {},
  },
  {
    id: 'nke_in_o',
    name: "NKE IN'O",
    fields: {},
  },
  {
    id: 'nke_press_o',
    name: "NKE Press'O",
    fields: {},
  },
  {
    id: 'nke_pulse_sens_o',
    name: "NKE Pulse Sens'O",
    fields: {},
  },
  {
    id: 'ott_hydromet_hl4',
    name: 'OTT HydroMet HL4',
    fields: {
      BusAddr: {
        name: 'BusAddr',
        order: 0,
        type: 'auto',
      },
      Cmd: {
        name: 'Cmd',
        order: 1,
        type: 'auto',
      },
      Index: {
        name: 'Index',
        order: 2,
        type: 'auto',
      },
      MsgID: {
        name: 'MsgID',
        order: 3,
        type: 'auto',
      },
      temperature: {
        name: 'temperature',
        order: 4,
        type: 'auto',
        value_type: {
          base_unit: '°C',
          descr: 'Deg. Celsius',
          factor: 1,
          group: 'Temperature',
          name: '°C',
        },
      },
      do_pct_sat: {
        name: 'do_pct_sat',
        order: 5,
        type: 'auto',
        value_type: {
          base_unit: '%',
          descr: 'Percent (0-100)',
          factor: null,
          group: 'Basic',
          name: 'Percent (0-100)',
        },
      },
      do_mgl: {
        name: 'do_mgl',
        order: 6,
        type: 'auto',
        value_type: {
          base_unit: 'number',
          descr: 'Number',
          factor: null,
          group: 'Basic',
          name: 'Number',
        },
      },
      salinity: {
        name: 'salinity',
        order: 7,
        type: 'auto',
        value_type: {
          base_unit: 'number',
          descr: 'Number',
          factor: null,
          group: 'Basic',
          name: 'Number',
        },
      },
      specific_conductivity: {
        name: 'specific_conductivity',
        order: 8,
        type: 'auto',
        value_type: {
          base_unit: 'number',
          descr: 'Number',
          factor: null,
          group: 'Basic',
          name: 'Number',
        },
      },
      total_dissolved_solids: {
        name: 'total_dissolved_solids',
        order: 9,
        type: 'auto',
        value_type: {
          base_unit: 'number',
          descr: 'Number',
          factor: null,
          group: 'Basic',
          name: 'Number',
        },
      },
      turbidity: {
        name: 'turbidity',
        order: 10,
        type: 'auto',
        value_type: {
          base_unit: 'number',
          descr: 'Number',
          factor: null,
          group: 'Basic',
          name: 'Number',
        },
      },
      depth: {
        name: 'depth',
        order: 11,
        type: 'auto',
        value_type: {
          base_unit: 'm',
          descr: 'Meter',
          factor: null,
          group: 'Distance',
          name: 'm',
        },
      },
    },
  },
  {
    id: 'parametric_people_pcr2',
    name: 'Parametric Radar People Counter Indoor PCR2',
    fields: {},
  },
  {
    id: 'sensing_labs_senlab_h',
    name: 'Sensing Labs SenlabH',
    fields: {
      battery_current_level: {
        name: 'battery_current_level',
        order: 2,
        type: 'auto',
        value_type: {
          base_unit: '%',
          descr: 'Percent (0-100)',
          factor: null,
          group: 'Basic',
          name: 'Percent (0-100)',
        },
      },
      humidity: {
        name: 'humidity',
        order: 3,
        type: 'auto',
        value_type: {
          base_unit: '%H',
          descr: 'Percent humidity',
          factor: 1,
          group: 'Basic',
          name: '% Humidity',
        },
      },
      temperature: {
        name: 'temperature',
        order: 0,
        type: 'auto',
        value_type: {
          base_unit: '°C',
          descr: 'Deg. Celsius',
          factor: 1,
          group: 'Temperature',
          name: '°C',
        },
      },
    },
  },
  {
    id: 'zenner_ehkv',
    name: 'Zenner caltos E Heizkostenverteiler',
    fields: {},
  },
  {
    id: 'zenner_rwm',
    name: 'Zenner Easy Protect Radio',
    fields: {},
  },
  {
    id: 'zenner_water_meter',
    name: 'Zenner Water Meter',
    fields: {},
  },
];

export default {
  data: function () {
    return {
      parserValueTypes: PARSER_VALUE_TYPES,
      predefinedParserVars: [
        { id: null, name: this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.noPredefinedParser') },
      ].concat(PARSER_CUSTOM),
    };
  },
  methods: {},
};
